<template>
    <div class="mb-3">
        <div class="card">
            <div class="card-body">
                <div class="form-row">
                    <div class="form-group col-md-5 col-sm-12">
                        <label class="col-form-label font-weight-bold" :for="'organizationalCalendarName' + _uid">{{ $t('organizationalCalendar.gridHeaders.name') }}</label>
                        <input v-if="editing" type="text" class="form-control"
                               v-model="model.name"
                               :name="'organizationalCalendarName' + _uid"
                               :id="'organizationalCalendarName' + _uid">
                        <input v-else type="text" readonly class="form-control-plaintext"
                               :name="'organizationalCalendarName' + _uid"
                               :id="'organizationalCalendarName' + _uid"
                               :value="model.name">
                    </div>
                    <div class="form-group col-md-5 col-sm-12">
                        <label class="col-form-label font-weight-bold" for="organizationalCalendarNameEn">{{ $t('organizationalCalendar.gridHeaders.nameEn') }}</label>
                        <input v-if="editing" v-model="model.nameEn" type="text" class="form-control" id="organizationalCalendarNameEn">
                        <input v-else type="text" readonly class="form-control-plaintext" id="organizationalCalendarNameEn" :value="model.nameEn">
                    </div>
                    <div class="form-group col-md-2 col-sm-12">
                        <label class="col-form-label font-weight-bold" for="organizationalModelDeactivated">{{ $t('organizationalCalendar.gridHeaders.applied') }}</label>
                        <span class="ml-2" :class="model.applied ? 'badge badge-success' : 'badge badge-danger'"> {{ model.applied ? $t('yes') : $t('no') }}</span>
                    </div>

                    <div class="form-group col-md-12 col-sm-12">
                        <label class="col-form-label font-weight-bold" for="organizationalModeldescription">{{ $t('organizationalModel.gridHeaders.description') }}</label>
                        <input v-if="editing" v-model="model.description" type="text" class="form-control" id="organizationalModeldescription">
                        <input v-else type="text" readonly class="form-control-plaintext" id="organizationalModeldescription" :value="model.description">
                    </div>
                </div>

                <div class="btn-group" v-if="!isLockedForEdit">
                    <button v-if="!editing && hasEditRights" class="btn btn-primary"
                            @click.stop="edit">
                        <i class="fas fa-edit"></i>
                        {{ $t('buttons.edit.btnText') }}
                    </button>
                    <button v-if="!editing && hasEditRights && hasLoadedCalendar" class="btn btn-info"
                            @click.stop="saveAsTemplate">
                        <i class="fas fa-share-square"></i>
                        {{ $t('buttons.saveAsTemplate.btnText') }}
                    </button>
                    <button v-if="!editing && hasEditRights && hasLoadedCalendar" class="btn btn-primary"
                            @click.stop="apply">
                        <i class="fas fa-tasks"></i>
                        {{ $t('buttons.apply.btnText') }}
                    </button>
                    <button v-if="editing && hasEditRights" class="btn btn-danger"
                            @click.stop="cancel">
                        <i class="fas fa-ban"></i>
                        {{ $t('buttons.cancel') }}
                    </button>
                    <button v-if="editing && hasEditRights" class="btn btn-success"
                            @click.stop="save">
                        <i class="fas fa-save"></i>
                        {{ $t('buttons.save.btnText') }}
                    </button>
                </div>

            </div>

            <div class="card-footer text-muted">
                {{ $t('organizationalCalendar.gridHeaders.createdAt') }}:{{ moment(model.createdAt).format('DD.MM.YYYY HH:mm') }}
            </div>
        </div>
    </div>



</template>

<script>
    import { Role } from '../../helpers/role';
    import { Culture } from '../../models/enums';
    import { OrganizationalCalendar } from '../../models/models';
    import moment from 'moment';

    export default {
        inject: ['$validator'],
        props: {
            organizationalCalendarModel: {
                type: OrganizationalCalendar,
                required: true,
            },
            details: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            }
        },
        components: {

        },
        data() {
            return {
                model: this.organizationalCalendarModel,
                editing: false,
                expanded: true,
                origValue: {
                    type: OrganizationalCalendar,
                    default: null
                },
                moment: moment

            }
        },
        methods: {
            edit() {
                this.updateOrgiValue(this.model);
                this.editing = true;
            },
            cancel() {
                if (!this.model) {
                    this.model = new OrganizationalCalendar(this.origValue);
                } else {
                    this.updateModel(this.origValue);
                }

                this.editing = false;
            },
            updateModel(m) {
                this.model.name = m.name;
                this.model.nameEn = m.nameEn;
                this.model.description = m.description;
                this.model.applied = m.applied;
            },
            updateOrgiValue(m) {
                if (!this.origValue) {
                    this.origValue = new OrganizationalModel();
                }

                this.origValue.name = m.name;
                this.origValue.nameEn = m.nameEn;
                this.origValue.description = m.description;
                this.origValue.applied = m.applied;
            },
            save() {
                this.update();
            },
            update() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.$http.put('/api/organizationalCalendar/update', this.model).then((response => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                text: this.$helpers.responseMessage(response),
                                color: 'success',
                                time: this.$store.getters.notificationDuration
                            });

                            if (response.data.model) {
                                this.updateModel(new OrganizationalCalendar(response.data.model));
                            }

                            this.editing = false;
                            this.$emit("saved", this.model);
                        })).catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });

                            this.cancel();
                        });
                    }
                });
            },
            saveAsTemplate() {
                let that = this;
                kendo.prompt(this.$t('namePromptTitle')).then(data => {
                    if (!data) {
                        that.$vs.notify({
                            title: `${that.$t('organizationalModel.title')} - ${that.$t('organizationalModel.gridHeaders.name')}`,
                            text: that.$t('missingData'),
                            color: 'warning',
                            time: that.$store.getters.notificationDuration
                        });

                        return;
                    }

                    that.doSaveAsTemplate(data);
                }, () => {

                })
            },
            doSaveAsTemplate(name) {
                let inputModel = new OrganizationalCalendar({ id: this.model.id, registerEntityId: this.model.registerEntityId, name: name });
                this.$http.post(`/api/organizationalCalendar/saveAsTemplate`, inputModel).then(response => {
                    this.$vs.notify({
                        title: this.$t('buttons.create.action'),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    });

                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
            apply() {
                kendo.confirm(this.$t('organizationalCalendar.applyConfirmation'))
                    .then(function () {
                        this.doApply()
                    }.bind(this));
            },
            doApply() {
                this.$http.post(`/api/organizationalCalendar/apply`, this.model).then(response => {
                    this.$vs.notify({
                        title: this.$t('buttons.apply.action'),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    });

                    this.model.applied = true;
                    this.$emit("applied");
                }).catch(error => {
                    console.log(error);

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
        },
        mounted() {

        },
        computed: {
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            hasEditRights() {
                return true;
            },
            hasLoadedCalendar() {
                let id = Number(this.model.id);
                return !isNaN(id);
            },
            //validNameValue() {
            //    if (!this.model.name) {
            //        return false;
            //    }

            //    return true;
            //}
        }
    }
</script>
